import { Int } from '@adornis/baseql/baseqlTypes.js';
import { baseqlMetaData } from '@adornis/baseql/metadata/metaDataStore.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CustomContent } from '@adornis/buildify/db/CustomContent';
import { of } from 'rxjs';
import { CustomContentFilter } from '../db/CustomContentFilter.js';

export const subscribeCustomContents = registerSubscription({
  type: () => [CustomContent],
  operationName: 'subscribeCustomContents',
  resolve: (skip: number, limit: number, filter?: CustomContentFilter) => {
    return (gqlFields: BaseQLSelectionSet<CustomContent>) => {
      if (!filter?.customContentClass) return of([]);
      const CustomContentClass = baseqlMetaData.entities
        .resolveNode(filter.customContentClass)
        .type() as typeof CustomContent;
      if (!CustomContentClass) return of([]);

      return watchQuery<CustomContent>(
        CustomContentClass._collectionName,
        {
          _class: CustomContentClass._class,
        },
        { skip, limit },
      );
    };
  },
  params: [
    { type: () => Int, name: 'skip' },
    { type: () => Int, name: 'limit' },
    { type: () => CustomContentFilter, name: 'filter' },
  ],
});
